import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { GET_QUESTIONNAIRES_SETTINGS } from './get-employee-questionnaire-settings.hook';
import { GET_QUESTIONNAIRES_SETTINGS_BY_ID } from './get-employee-questionnaire-settings-by-id.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_ALL_QUESTIONNAIRES_SETTINGS } from './get-all-employee-questionnaire-settings.hook';
import { GET_QUESTIONNAIRES_SETTINGS_BY_IDS } from './get-employee-questionnaire-settings-by-ids.hook';


export const DELETE_QUESTIONNAIRES_SETTINGS_BY_ID = gql`
  mutation deleteEmployeeQuestionnaireSettingById($id: String!) {
    deleteEmployeeQuestionnaireSettingById(id: $id) {
      _id
    }
  }
`;

export const useDeleteEmployeeQuestionnaireSettingById = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { t } = useTranslation('settings');
  const [deleteEmployeeQuestionnaireSetting] = useMutation(DELETE_QUESTIONNAIRES_SETTINGS_BY_ID, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteEmployeeQuestionnaireSettingById?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('employeeQuestionnaire.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [
      GET_QUESTIONNAIRES_SETTINGS,
      GET_ALL_QUESTIONNAIRES_SETTINGS,
      GET_QUESTIONNAIRES_SETTINGS_BY_ID,
      GET_QUESTIONNAIRES_SETTINGS_BY_IDS
    ],
  });

  return deleteEmployeeQuestionnaireSetting;
};
